import { Modal, Stack, Title } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { Button, InfoBox } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { CertificateUpdateDto } from "@tfg/types/schemas/modules/traceability/commands/update-certificate/update-certificate.request.dto"

import { FindCertificatesByOrganizationIdResponseDto } from "~/gen/api"
import { CertificateSummary } from "~/pages/Brand/Certificates/components/CertificateSummary.tsx"

type Props = {
  form: UseFormReturnType<CertificateUpdateDto>
  certificate: FindCertificatesByOrganizationIdResponseDto
  onClose: () => void
  onSubmit: () => void
  opened: boolean
}
export function SuccessModal({
  onClose,
  certificate,
  onSubmit,
  opened,
  form,
}: Props) {
  const { t } = useTranslation("certificates")
  if (!form) {
    return null
  }
  return (
    <Modal.Root opened={opened} onClose={onClose}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>
            <Title order={4}>{t("modal.successModal.title")}</Title>
          </Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <Stack>
            <InfoBox
              message={t("modal.successModal.warning")}
              size="xs"
              color="orange"
            />
            <CertificateSummary certificate={certificate} />
            <Button
              w="100%"
              onClick={() => {
                onSubmit()
              }}
            >
              {t("modal.successModal.submit")}
            </Button>
          </Stack>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  )
}
